import TextField from '@/components/inputs/TextField';

export type ExternalRefFieldProps = {
  error?: boolean;
  className?: string;
  value: string;
  onChange: (update: string) => void;
};

export default function ExternalRefField({
  className,
  error,
  value,
  onChange,
}: ExternalRefFieldProps) {
  return (
    <TextField
      error={error}
      className={className}
      label="External Ref. (optional)"
      value={value}
      onChange={onChange}
    />
  );
}
